module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('x-cell', [_c('div', {
    staticClass: "mint-checkbox-new-row",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('label', {
    staticStyle: {
      "width": "100%",
      "display": "block"
    }
  }, [_c('span', {
    staticClass: "mint-checkbox-new",
    class: {
      'is-right': _vm.align === 'right'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    staticClass: "mint-checkbox-new-input",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.isDisabled
    },
    domProps: {
      "checked": Array.isArray(_vm.currentValue) ? _vm._i(_vm.currentValue, null) > -1 : (_vm.currentValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.currentValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.currentValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.currentValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.currentValue = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "mint-checkbox-new-core",
    class: ['mint-checkbox-new-core-' + _vm.iconpattern, {
      'mt-bg-after-white': _vm.iconpattern === 'circle'
    }, _vm.isDisabled ? 'mt-bg-grey-lv6 mt-bColor-grey-lv6 mt-bColor-after-white' : (_vm.currentValue ? 'mt-bg-primary mt-bColor-primary mt-bColor-after-white' : 'mt-bColor-grey-lv3 mt-bg-lv3')]
  })]), _c('span', {
    staticClass: "mint-checkbox-new-label",
    class: [_vm.isDisabled ? 'mt-color-grey-lv3' : 'mt-color-grey']
  }, [_vm._t("default")], 2)]), _vm._t("newline", null, {
    checked: _vm.isChecked,
    disabled: _vm.isDisabled
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56ef1b1b","hasScoped":false,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/checkbox/src/checkbox.vue
// module id = 394
// module chunks = 0